import React, { FC } from 'react';
import { PrimaryButton } from '../atoms';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { PopupTransition } from '../atoms/Transitions';

interface Props {
    title?: string;
    onConfirm: () => void;
    onHide: () => void;
    show: boolean;
}

export const ConfirmModalPanel: FC<Props> = ({title,
                                                      onConfirm = () => {},
                                                      onHide = () => {},
                                                    show}) => {
    return (
        <Dialog
            maxWidth="sm"
            TransitionComponent={PopupTransition}
            keepMounted
            fullWidth
            onClose={onHide}
            open={show}
            sx={{ '& .MuiDialog-paper': { p: 0 }, transition: 'transform 225ms' }}
            aria-describedby="alert-dialog-slide-description">
            <DialogTitle>Weetje het zeker?</DialogTitle>
            <DialogContent>
                {title}
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="secondary" onClick={onHide}>
                    Sluiten
                </Button>
                <PrimaryButton onClick={() => onConfirm()}>
                    OK
                </PrimaryButton>
            </DialogActions>
        </Dialog>
    )
};


